import { SalesQuotationStatus } from "./enums/sales-quotation-status.enum"

export const SalesQuotationStatusLabels=[
{
    key:SalesQuotationStatus.Draft.toString(),
    textClass: 'text-blue-600',
    bgClass: 'bg-blue-600/10',
},{
    key:SalesQuotationStatus.WaitingCustomerAcceptance.toString(),
    textClass: 'text-indigo-600',
    bgClass: 'bg-indigo-600/10',
},
{
    key:SalesQuotationStatus.Synced.toString(),
    textClass: 'text-yellow-600',
    bgClass: 'bg-yellow-600/10',
},
{
    key:SalesQuotationStatus.Accepted.toString(),
    textClass: 'text-emerald-600',
    bgClass: 'bg-emerald-600/10',
},
{
    key:SalesQuotationStatus.RejectedByCustomer.toString(),
    textClass: 'text-red-600',
    bgClass: 'bg-red-600/10',
},
{
    key:SalesQuotationStatus.Cancelled.toString(),
    bgClass: 'bg-amber-600',
    textClass: 'text-white'}

]